import { render, staticRenderFns } from "./PaymentsOtrosPagos.vue?vue&type=template&id=58b3b73c&"
import script from "./PaymentsOtrosPagos.vue?vue&type=script&lang=js&"
export * from "./PaymentsOtrosPagos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports